import React from 'react';
import { motion } from 'framer-motion';
export function HeartbeatDivider() {
  return <div className="w-full flex justify-center py-16 opacity-40" aria-hidden="true" data-id="element-10">
      <motion.svg width="240" height="40" viewBox="0 0 240 40" fill="none" xmlns="http://www.w3.org/2000/svg" initial={{
      pathLength: 0,
      opacity: 0
    }} whileInView={{
      pathLength: 1,
      opacity: 1
    }} viewport={{
      once: true,
      margin: '-50px'
    }} transition={{
      duration: 1.5,
      ease: 'easeInOut'
    }} data-id="element-11">
        <motion.path d="M0 20H80L90 5L105 35L115 15L125 25L135 20H240" stroke="#2c7a7b" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-12" />
      </motion.svg>
    </div>;
}